import vars from '../../vars';
import PerfectScrollbar from 'perfect-scrollbar';



	$(document).ready(function() {
		if (jQuery(window).width() >= 1024) {
			var countList = vars.$itemKeyWords.length;		
			if (countList > 7) {
				vars.$asideAll.removeClass("hide");
			} else {
				vars.$asideAll.addClass("hide");
			}
		}
	});

	var ps;
	$(document).ready(function() {
		var ismobile = false;
		function initScroll() {
			if($('.js-scroll-materials').height() > 0) {
				ps = new PerfectScrollbar('.js-scroll-materials', {
					wheelSpeed:0.2,
					wheelPropagation: true,
					minScrollbarLength:180,
					maxScrollbarLength:180,
				})
			}
		}

		vars.$asideAll.click(function() {
			vars.$asideKeyWords.toggleClass("active");
			if ($('.b-aside-filter__aside-list').hasClass("active")) {
				initScroll();
				vars.$asideAll.text("Скрыть");
			} else {
				vars.$asideAll.text("Показать все");
				$('.js-scroll-materials').scrollTop(0)
				ps.destroy();
				
			}
		})
		
		$(window).on('resize',function() {
			if (($(window).width() > 1023) && ismobile) {
				$('.js-scroll-materials').scrollTop(0)
				ps.destroy();
				ismobile = false;
			} 

			if (($(window).width() <= 1023) && !ismobile) {
				initScroll();
				ismobile = true;
			}
		});

		if ($(window).width() <= 1023) {
			initScroll();
			ismobile = true;
		}		
	});





// WEBPACK FOOTER //
// ./src/js/pages/materials/aside-key-words.js